import React, { PropTypes, Component } from 'react'
import classes from './ProductItem.scss'

class GiveawayItem extends Component {
  static propTypes = {
    product: PropTypes.object.isRequired
  };

  static defaultProps = {
    product: {},
    userClass: 0,
    amount: 0
  };

  constructor (props) {
    super(props)
    this.state = { amount: props.amount || 1 }
  }

  componentDidMount () {
    window.objectFitImages()
    const images = document.getElementsByTagName('img')
    Object.keys(images).forEach(key => images[key].addEventListener('contextmenu', () => false))
  }

  render () {
    const { product, onClick, active } = this.props
    return (
      <div ref='productItem' className={classes.productItem} id={product.productCode}>
        <div className='desktop'>
          <div className={classes.thumbnailWrapper}>
            <img role='presentation' className={classes.thumbnail} src={product.imagePath} />
            <div className={classes.watermarkWrapper}>
              <img className={classes.watermark} src='/images/watermark.png' alt='watermark' width='60' height='20' />
            </div>
          </div>
        </div>
        <div className='mobile'>
          <div className={classes.thumbnailWrapper}>
            <img role='presentation' className={classes.thumbnail} src={product.imagePath} />
            <div className={classes.watermarkWrapper}>
              <img className={classes.watermark} src='/images/watermark.png' alt='watermark' width='60' height='20' />
            </div>
          </div>
        </div>
        <div className={`desktop ${classes.container}`}>
          <div className={classes.giveawayName}>{product.productName}</div>
        </div>
        <div className='mobile'>
          <div className={classes.giveawayName}>{product.productName}</div>
        </div>
        <div className={`${classes.btnChoose} ${active && classes.active}`} onClick={onClick}>
          {active ? 'เลือกชิ้นนี้แล้ว' : 'เลือกชิ้นนี้'}
        </div>
      </div>
    )
  }
}

export default GiveawayItem



/** WEBPACK FOOTER **
 ** ./src/components/GiveawayItem.js
 **/